import styled from 'styled-components';
import { Layout, Menu as AntMenu, Drawer as AntDrawer } from 'antd';

const backgroundColor = props => (props.theme === 'dark' ? '#001529' : '#FFF');

export const Sider = styled(Layout.Sider)`
  height: 100vh;
  background-color: ${backgroundColor} !important;

  .ant-layout-sider-trigger {
    background-color: ${backgroundColor} !important;
  }

  .ant-menu-inline-collapsed {
    .ant-menu-submenu {
      height: 45px;
    }

    .ant-menu-submenu-title {
      display: flex;
      align-items: center;
      
      span {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        i {
          margin-top: 5px;
          line-height: 10px !important;

          + span {
            display: flex !important;
            margin-top: 5px;
            line-height: 10px !important;
            opacity: 1 !important;
          }
        }
      }
    }
  }
`;

export const Menu = styled(AntMenu)`
  height: 100%;
`;

export const Drawer = styled(AntDrawer)`
  .ant-drawer-wrapper-body {
    background-color: ${backgroundColor} !important;
  }

  .ant-drawer-body {
    padding: 0 !important;
  }
`;

export const IconImg = styled.img`
  width: 14px;
  margin-right: 10px;
`;
